import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { siteLabelFromOrigin } from '@/helper/getSubDomain';

/**
 * Document title: prefer outlet name (production), then subdomain / APP before login.
 */
export default function JTHelmet({ description = 'Jungle Toppings', content = 'Jungle Toppings' }) {
	const jtTitle = import.meta.env.VITE_TITLE_APP;
	const selectedOutlet = useSelector((state) => state.auth.selectedOutlet);
	const parentOutlet = useSelector((state) => state.auth.parentOutlet);
	const siteLabel = siteLabelFromOrigin(typeof window !== 'undefined' ? window.origin : '');

	const outletLabel =
		(selectedOutlet?.name && String(selectedOutlet.name).trim()) ||
		(parentOutlet?.name && String(parentOutlet.name).trim()) ||
		'';
	const contentTitle = `${outletLabel || siteLabel || 'APP'} | ${jtTitle}`;

	return (
		<HelmetProvider>
			<Helmet>
				<title>{contentTitle}</title>
				<meta name={description} content={content} />
			</Helmet>
		</HelmetProvider>
	);
}
